import { z } from 'zod';

export const chatMentionSchema = z.object({
  entityId: z.string(),
  objectId: z.string().optional(),
  name: z.string(),
  type: z.string(),
  link: z.string().optional(),
});
export type ChatMention = z.infer<typeof chatMentionSchema>;
